<template>
  <div class="supplier-table-wrapper">
    <el-container>
      <el-header>
        <div class="handlePanel">
          <el-button
            type="primary"
            icon="el-icon-download"
            @click="downloadTemplate"
            >下载模板</el-button
          >
          <el-button type="primary" icon="el-icon-upload2" @click="importData"
            >导入</el-button
          >
          <el-button type="primary" icon="el-icon-download" @click="exportData"
            >导出</el-button
          >
          <el-button type="primary" icon="el-icon-plus" @click="createItem"
            >新增</el-button
          >
          <el-button type="primary" icon="el-icon-delete" @click="deleteItems"
            >删除</el-button
          >
          <el-button type="primary" icon="el-icon-edit" @click="editItem"
            >修改</el-button
          >
        </div>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="dataTable"
          :data="tableData"
          highlight-current-row
          size="mini"
          height="100%"
          border
          @selection-change="handleSelectionChange"
          @row-click="handleRowClick"
        >
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="供应商名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="bankName"
            label="开户行名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="bankAccount"
            label="账户"
            :show-overflow-tooltip="true"
          ></el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible">
      <el-form
        :model="dialogData"
        :rules="dialogRules"
        ref="dialogForm"
        label-position="right"
        label-width="100px"
      >
        <el-form-item prop="name" label="供应商名称">
          <el-input
            v-model="dialogData.name"
            placeholder="请输入..."
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="bankName" label="开户行名称">
          <el-input
            v-model="dialogData.bankName"
            placeholder="请输入..."
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="bankAccount" label="账户">
          <el-input
            v-model="dialogData.bankAccount"
            placeholder="请输入..."
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <template v-if="dialogState == 'create'">
          <el-button type="info" @click="cancelCreateItem">取消</el-button>
          <el-button type="primary" @click="confirmCreateItem">确定</el-button>
        </template>
        <template v-else-if="dialogState == 'edit'">
          <el-button type="info" @click="cancelEditItem">取消</el-button>
          <el-button type="primary" @click="confirmEditItem">确定</el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSupplierItemsService,
  createSupplierItemService,
  deleteSupplierItemsService,
  editSupplierItemService,
} from "../../services/basicDataService";
import Constants from "@/utils/consts";
export default {
  name: "SupplierTable",
  data() {
    return {
      tableData: [],
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      selectedItems: [],
      dialogTitle: "",
      dialogVisible: false,
      dialogData: {},
      dialogState: "",
      dialogRules: {
        name: [
          { required: true, message: "请输入供应商名称", trigger: ["blur"] },
        ],
        bankName: [
          { required: true, message: "请输入开户行名称", trigger: ["blur"] },
        ],
        bankAccount: [
          { required: true, message: "请输入账户", trigger: ["blur"] },
        ],
      },
    };
  },
  methods: {
    onActive() {
      console.log("onactive 供应商列表");
      this.initList();
    },
    initList() {
      getSupplierItemsService({
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      })
        .then((res) => {
          console.log(res);
          if (res.code == 10000000) {
            this.tableData = res.data || [];
            this.total = res.total;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error.message, "提示");
        });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageIndex = 1;
      this.initList();
    },
    handleCurrentChange(page) {
      this.pageIndex = page;
      this.initList();
    },
    downloadTemplate() {
      // 下载模板
    },
    importData() {
      // 导入可能的bug：excel为空，但其实不为空，用office打开再保存下就可以了
    },
    exportData() {},
    createItem() {
      this.dialogTitle = "新增供应商信息";
      this.dialogData = {
        name: "",
        bankName: "",
        bankAccount: "",
      };
      this.dialogState = "create";
      this.dialogVisible = true;
    },
    confirmCreateItem() {
      this.$refs["dialogForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        let params = { ...this.dialogData };

        createSupplierItemService(params)
          .then((res) => {
            if (res.code == Constants.Code_OK) {
              this.cancelCreateItem();
              this.$alert(Constants.Ok_Msg, "提示");
              this.initList();
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch((error) => {
            this.$alert(error instanceof Error ? error.message : error, "提示");
          });
      });
    },
    cancelCreateItem() {
      this.dialogVisible = false;
      this.dialogTitle = "";
      this.dialogData = {};
      this.dialogState = "";
      this.$refs["dialogForm"].resetFields();
    },
    deleteItems() {
      // 删除，可以多删
      if (!this.selectedItems || this.selectedItems.length == 0) {
        this.$alert("请先选择要删除的数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.$confirm("您确定要删除选定的数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = [];
          for (let i = 0; i < this.selectedItems.length; i++) {
            ids.push(this.selectedItems[i].id);
          }
          ids = ids.join(",");
          return deleteSupplierItemsService({ supplierIdSet: ids });
        })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.$alert(Constants.Ok_Msg, "提示");
            this.initList();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          if (error instanceof Error) {
            this.$alert(error.message, "提示");
          }
        });
    },
    editItem() {
      // 修改只能单条
      if (
        !this.selectedItems ||
        this.selectedItems.length == 0 ||
        this.selectedItems.length > 1
      ) {
        this.$alert("请选择要修改的数据，每次只能修改一条数据", "提示");
        return;
      }

      this.dialogTitle = "修改供应商信息";
      this.dialogData = { ...this.selectedItems[0] };
      this.dialogState = "edit";
      this.dialogVisible = true;
    },
    cancelEditItem() {
      this.dialogVisible = false;
      this.dialogTitle = "";
      this.dialogData = {};
      this.dialogState = "";
      this.$refs["dialogForm"].resetFields();
    },
    confirmEditItem() {
      this.$refs["dialogForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        let params = { ...this.dialogData };

        editSupplierItemService(params)
          .then((res) => {
            if (res.code == Constants.Code_OK) {
              this.cancelEditItem();
              this.$alert(Constants.Ok_Msg, "提示");
              this.initList();
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch((error) => {
            this.$alert(error instanceof Error ? error.message : error, "提示");
          });
      });
    },

    handleSelectionChange(val) {
      this.selectedItems = val || [];
      console.log(val);
    },
    handleRowClick(row, column) {
      console.log("handleRowClick", row, column);
      if (!this.selectedItems) {
        this.selectedItems = [row];
      } else {
        let index = this.selectedItems.indexOf(row);
        if (index != -1) {
          this.selectedItems.splice(index, 1);
        } else {
          this.selectedItems.push(row);
        }
      }
      this.$refs["dataTable"].toggleRowSelection(row);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.supplier-table-wrapper {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.el-footer {
  text-align: right;
}

.handlePanel {
  text-align: right;
  margin-top: 16px;
}
</style>
